import React from "react";
import styled from "styled-components";
import Social from "./Social";

const Footer = () => {
  return (
    <Section>
      <Social />
      <Text>
        <p>Designed by Brittany Chiang & Built by Tushar</p>
      </Text>
    </Section>
  );
};

export default Footer;

const Section = styled.footer`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  text-align: center;
  color: var(--light-slate);
  font-family: ${(props) => props.theme.fonts.sf};
  font-size: var(--fz-xxs);
  line-height: 1;

  
  
`;
const Text = styled.div`
padding: 10px;
min-height: 70px;
  padding: 15px;
p{
  margin-bottom: 0px;
}
`;